import { ApiResponse } from "@apis/api.ts";
import httpClient from "@plugins/http";
import {
  FileUploadResult,
  FileUploadModel,
  FileUploadRequest,
} from "@plugins/file-uploader-v2/types.ts";
import appConfigs from "@configs/app";
import { cookieManager } from "@utils/cookie.manager.ts";

const generateFileUploadUrl = async (
  payload: FileUploadRequest,
): Promise<ApiResponse<FileUploadModel>> => {
  const token = cookieManager.getCookie("jwt_token");

  if (!token) {
    throw new Error("Access Denied: No jwt token found");
  }

  return await httpClient.post(appConfigs.fileScanUrl, payload, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

const getVirusScanningStatus = async (uuid: string): Promise<ApiResponse<FileUploadResult>> => {
  return await httpClient.get(`${appConfigs.fileScanStatusUrl}${uuid}`);
};

const uploadFile = async (url: string, file: File) => {
  return await httpClient.put(url, file, {
    headers: { "Content-Type": file.type },
  });
};

const getSuccessFileBlob = async (path: string) => {
  return await httpClient.get(`${appConfigs.s3ResourceDomain}/success/${path}`, {
    withCredentials: true,
    responseType: "blob",
  });
};

export default {
  uploadFile,
  generateFileUploadUrl,
  getVirusScanningStatus,
  getSuccessFileBlob,
};
